import {
  getTaskTagPage,
  addTaskTag,
  updateTaskTag,
  deleteTaskTag,
} from '@/_serveice/project/tag';
import { message } from 'antd';

export default {
  namespace: 'tagManage',
  state: {
    tagList: [],
  },
  effects: {
    *getTaskTagPage({ payload }, { call, put }) {
      const res = yield call(getTaskTagPage, payload);
      if (res?.success) {
        yield put({
          type: 'save',
          payload: {
            tagList: res.data,
          },
        });
        return res;
      }
    },
    *addTaskTag({ payload }, { call }) {
      const res = yield call(addTaskTag, payload);
      if (res?.success) {
        message.success('新增成功');
        return res;
      }
    },
    *updateTaskTag({ payload }, { call }) {
      const res = yield call(updateTaskTag, payload);
      if (res?.success) {
        message.success('修改成功');
        return res;
      }
    },
    *deleteTaskTag({ payload }, { call }) {
      const res = yield call(deleteTaskTag, payload);
      if (res?.success) {
        message.success('删除成功');
        return res;
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
